import React from 'react';
import PropTypes from 'prop-types';
import { AccessRequestsBarWidget } from './AccessRequestsBarWidget';

export const Widget = props => {
  return <AccessRequestsBarWidget {...props} />;
};

Widget.displayName = 'utility/AccessRequestsBarWidget';

Widget.propTypes = {
  data: PropTypes.shape({
    user: PropTypes.shape({}),
  }),
};

Widget.defaultProps = {
  data: {},
};
